module.exports = __webpack_public_path__ + "img/mergdata_mob_3.39c019de.png";